export default __webpack_public_path__ + "static/media/HSPI.25e14919.png";